import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { Processo, TipoVinculacaoOptions } from '../../models/processo';
import { ProjetoCadastro } from 'src/app/modules/projeto-completo/models/projeto-cadastro.model';
import { PesquisaGeralService } from 'src/app/modules/projeto-completo/services/pesquisa-geral.service';
import { ProjetoCadastroService } from 'src/app/modules/projeto-completo/services/projeto-cadastro.service';
import { MaskService } from 'src/app/shared/services/mask.service';

@Component({
  selector: 'app-processo-list',
  templateUrl: './processo-list.component.html',
  styleUrls: ['./processo-list.component.scss']
})
export class ProcessoListComponent extends BaseListComponent<Processo> implements OnInit, OnDestroy {
  
  idProjeto: number;
  blocked: boolean;
  infoProjeto: ProjetoCadastro;
  project: ProjetoCadastro;
  processo: Processo[];
  processoPesquisa: Processo[];
  filterPesquisa: string = '';
  ordenarList = [
    { id: 'old_processo', label: 'Maior tempo sem Movimentação' },
    { id: 'recent_processo', label: 'Menor tempo sem Movimentação' },
    { id: 'processo_number', label: 'Padrão' },
  ];
  @Input() currentService;
  @Input() route:string;

  constructor(
    private projectService: ProjetoCadastroService,
    private pesquisaGeralService: PesquisaGeralService,
    private maskService: MaskService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.blocked = true;

      this.addSub(
        this.projectService.getById(this.idProjeto).subscribe((res) => {
          this.project = res;
          this.blocked = this.project.full_blocked;
        })
      );

      this.get();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  get(){
    this.loading();
    this.currentService.listProcess(this.idProjeto).subscribe({
      next: (res: Processo[]) => {
        this.processo = res;
        this.processoPesquisa = res;
        this.loaded();
      },
      error: (error) => {
        this.msgError(error?.error?.message);
        this.loaded();
      },
    })
  }

  pesquisaRapida() {
    this.processoPesquisa = this.processo.filter(item => this.onMaskProcesso(item?.numero_processo).toLowerCase().includes(this.filterPesquisa.toLowerCase()));
  }

  onMaskProcesso(valor: string): string{
    return this.maskService.mascaraProcesso(valor);
  }

  getVinculos(vinculos:any): void{

    return vinculos.map((v)=> {
      const option = TipoVinculacaoOptions.find(t => t.id == v.tipo_vinculacao);
      const newData = {...v, ...option};
      return newData;
    })
  }
}
